import React, { useEffect, useRef, useState } from 'react';
import { 
  FaNewspaper, FaCalendarAlt, FaArrowRight, FaShare,
  FaEye, FaThumbsUp, FaRegClock, FaTag, FaBell,
  FaGraduationCap, FaTrophy, FaUsers, FaBookOpen,
  FaChalkboardTeacher, FaLaptop, FaFlask, FaMusic,
  FaHeart, FaStar, FaCertificate, FaMicrophone
} from 'react-icons/fa';
import { MdOutlineEventNote, MdOutlineAnnouncement } from 'react-icons/md';

const NewsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('latest');
  const [selectedNews, setSelectedNews] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const latestNews = [
    {
      id: 1,
      title: " BNS College Ranked Among Top 10 Women's Colleges in Uttar Pradesh",
      date: "15 March 2024",
      category: "Achievement",
      description: "BNS Mahila Maha Vidyalaya has been recognized as one of the top 10 women's colleges in Uttar Pradesh by Education Today. This prestigious recognition highlights our commitment to quality education and women empowerment.",
      image: "image1.png",
      icon: <FaTrophy />,
      color: "from-yellow-500 to-orange-500",
      views: 1245,
      likes: 89
    },
    {
      id: 2,
      title: " Admission Open for B.A., B.Sc., B.Com Session 2024-25",
      date: "10 March 2024",
      category: "Admission",
      description: "Applications are now invited for undergraduate programs. Last date to apply is 30th June 2024. Limited seats available. Scholarship for meritorious students.",
      image: "image6.png",
      icon: <FaGraduationCap />,
      color: "from-green-500 to-teal-500",
      views: 2345,
      likes: 156
    },
    {
      id: 3,
      title: "Annual Sports Meet 2024 - Registration Open",
      date: "5 March 2024",
      category: "Event",
      description: "Annual Sports Meet will be held from 15-20 April 2024. Events include Cricket, Football, Badminton, Athletics, and more. All students are encouraged to participate.",
      image: "image10.png",
      icon: <FaTrophy />,
      color: "from-orange-500 to-red-500",
      views: 1890,
      likes: 112
    },
    {
      id: 4,
      title: " Grand Celebration of International Women's Day",
      date: "8 March 2024",
      category: "Event",
      description: "College celebrated International Women's Day with great enthusiasm. Guest speakers included renowned women entrepreneurs and social activists. Cultural programs were organized.",
      image: "image15.png",
      icon: <FaUsers />,
      color: "from-pink-500 to-rose-500",
      views: 1567,
      likes: 234
    },
    {
      id: 5,
      title: "500+ New Books Added to Central Library",
      date: "1 March 2024",
      category: "Facility",
      description: "Central Library has added 500+ new books including reference books, competitive exam materials, and digital resources. E-journal subscription also expanded.",
      image: "image20.png",
      icon: <FaBookOpen />,
      color: "from-blue-500 to-indigo-500",
      views: 890,
      likes: 67
    },
    {
      id: 6,
      title: " New Computer Lab Inaugurated with 50+ Systems",
      date: "25 February 2024",
      category: "Infrastructure",
      description: "State-of-the-art computer lab with 50+ high-end systems and high-speed internet was inaugurated. Students can now access digital learning resources easily.",
      image: "image30.png",
      icon: <FaLaptop />,
      color: "from-cyan-500 to-blue-500",
      views: 1123,
      likes: 89
    }
  ];

  const events = [
    {
      id: 1,
      title: " Career Counseling & Placement Drive",
      date: "25 March 2024",
      time: "10:00 AM - 4:00 PM",
      venue: "Seminar Hall",
      description: "Leading companies will visit campus for placement drive. Career guidance session for final year students.",
      color: "from-yellow-500 to-orange-500",
      icon: <FaChalkboardTeacher />
    },
    {
      id: 2,
      title: " Science Exhibition & Project Competition",
      date: "5 April 2024",
      time: "9:00 AM - 5:00 PM",
      venue: "Science Block",
      description: "Students will showcase innovative science projects. Prizes for best projects.",
      color: "from-blue-500 to-cyan-500",
      icon: <FaFlask />
    },
    {
      id: 3,
      title: " Annual Cultural Fest 'Udaan 2024'",
      date: "25-30 April 2024",
      time: "10:00 AM onwards",
      venue: "College Ground",
      description: "Annual cultural festival featuring dance, music, drama, fashion show, and various competitions.",
      color: "from-purple-500 to-pink-500",
      icon: <FaMusic />
    },
    {
      id: 4,
      title: " Parent-Teacher Meeting",
      date: "10 April 2024",
      time: "10:00 AM - 2:00 PM",
      venue: "College Auditorium",
      description: "Quarterly parent-teacher meeting to discuss student progress and performance.",
      color: "from-green-500 to-teal-500",
      icon: <FaUsers />
    },
    {
      id: 5,
      title: "Inter-College Sports Championship",
      date: "15-20 May 2024",
      time: "8:00 AM - 5:00 PM",
      venue: "Sports Complex",
      description: "Inter-college sports competition. Teams from various colleges will participate.",
      color: "from-red-500 to-orange-500",
      icon: <FaTrophy />
    },
    {
      id: 6,
      title: " Entrepreneurship Development Workshop",
      date: "18 April 2024",
      time: "11:00 AM - 3:00 PM",
      venue: "Conference Hall",
      description: "Workshop on startup ideas, business planning, and entrepreneurship skills.",
      color: "from-indigo-500 to-purple-500",
      icon: <FaMicrophone />
    }
  ];

  const announcements = [
    { id: 1, title: " College Ranked Top 10 in UP", date: "15 March 2024", type: "Achievement", icon: <FaTrophy /> },
    { id: 2, title: " Scholarship Application Deadline Extended to 30th April", date: "10 March 2024", type: "Scholarship", icon: <FaCertificate /> },
    { id: 3, title: " Mid-Semester Examinations from 15th February", date: "5 Feb 2024", type: "Exam", icon: <FaBookOpen /> },
    { id: 4, title: " College Foundation Day Celebration on 27th February", date: "20 Feb 2024", type: "Event", icon: <FaHeart /> },
    { id: 5, title: " Summer Vacation from 15th May to 30th June", date: "1 May 2024", type: "Vacation", icon: <FaStar /> },
    { id: 6, title: " Free Computer Training Program for Students", date: "5 April 2024", type: "Course", icon: <FaLaptop /> },
    { id: 7, title: " Farewell Party for Final Year Students", date: "30 April 2024", type: "Event", icon: <FaGraduationCap /> },
    { id: 8, title: "Library will remain open on Sundays during exams", date: "25 March 2024", type: "Facility", icon: <FaBookOpen /> }
  ];

  const tabs = [
    { id: 'latest', name: 'Latest News', icon: <FaNewspaper /> },
    { id: 'events', name: 'Events', icon: <MdOutlineEventNote /> },
    { id: 'announcements', name: 'Announcements', icon: <MdOutlineAnnouncement /> }
  ];

  return (
    <section ref={sectionRef} className="w-full bg-gradient-to-br from-yellow-50 via-pink-50 to-orange-50 py-16">
      <div className="w-full px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          
          {/* Decorative Top */}
          <div className="flex justify-center gap-3 mb-6">
            <div className="w-12 h-1 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full"></div>
            <div className="w-8 h-1 bg-gradient-to-r from-orange-400 to-orange-500 rounded-full"></div>
            <div className="w-6 h-1 bg-gradient-to-r from-pink-400 to-pink-500 rounded-full"></div>
          </div>

          {/* Heading */}
          <div className={`text-center mb-10 transition-all duration-700 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}>
            <div className="flex justify-center mb-3">
              <div className="bg-gradient-to-r from-yellow-500 via-orange-500 to-pink-500 p-3 rounded-2xl shadow-lg">
                <FaBell className="text-white text-3xl" />
              </div>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-3">
              <span className="bg-gradient-to-r from-yellow-600 via-orange-600 to-pink-600 bg-clip-text text-transparent">
                Campus News & Updates
              </span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 via-orange-500 to-pink-500 rounded-full mx-auto"></div>
            <p className="text-gray-600 text-sm mt-4">
              Latest happenings, achievements, and events at BNS Mahila Maha Vidyalaya
            </p>
          </div>

          {/* Tab Buttons */}
          <div className={`flex flex-wrap justify-center gap-3 mb-10 transition-all duration-500 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-5 py-2 rounded-xl font-semibold text-sm transition-all duration-300 ${
                  activeTab === tab.id
                    ? 'bg-gradient-to-r from-yellow-500 to-orange-500 text-white shadow-lg scale-105'
                    : 'bg-white text-gray-600 hover:bg-gray-100'
                }`}
              >
                {tab.icon}
                {tab.name}
              </button>
            ))}
          </div>

          {/* Latest News Tab */}
          {activeTab === 'latest' && (
            <div className={`grid md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-500 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}>
              {latestNews.map((news, idx) => (
                <div key={news.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:-translate-y-2 group">
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={news.image} 
                      alt={news.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className={`absolute top-3 left-3 bg-gradient-to-r ${news.color} text-white text-xs px-2 py-1 rounded-full flex items-center gap-1`}>
                      {news.icon}
                      <span>{news.category}</span>
                    </div>
                    <div className="absolute bottom-3 right-3 bg-black/60 backdrop-blur-sm rounded-full px-2 py-1">
                      <div className="flex items-center gap-1 text-white text-xs">
                        <FaCalendarAlt className="text-yellow-400 text-xs" />
                        <span>{news.date}</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="font-bold text-gray-800 text-md mb-2 line-clamp-2">{news.title}</h3>
                    <p className="text-gray-600 text-xs leading-relaxed mb-4 line-clamp-3">{news.description}</p>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className="flex items-center gap-1 text-gray-400 text-xs">
                          <FaEye className="text-xs" /> {news.views}
                        </div>
                        <div className="flex items-center gap-1 text-gray-400 text-xs">
                          <FaThumbsUp className="text-xs" /> {news.likes}
                        </div>
                      </div>
                      <button className="text-orange-500 text-xs font-semibold flex items-center gap-1 hover:gap-2 transition-all">
                        Read More <FaArrowRight className="text-xs" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Events Tab */}
          {activeTab === 'events' && (
            <div className={`grid md:grid-cols-2 lg:grid-cols-3 gap-5 transition-all duration-500 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}>
              {events.map((event, idx) => (
                <div key={event.id} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all hover:-translate-y-1">
                  <div className={`bg-gradient-to-r ${event.color} p-3 text-white`}>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                          {event.icon}
                        </div>
                        <h3 className="font-bold text-sm line-clamp-1">{event.title}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 space-y-2">
                    <div className="flex items-center gap-2 text-gray-600 text-xs flex-wrap">
                      <FaCalendarAlt className="text-orange-500" />
                      <span>{event.date}</span>
                      <FaRegClock className="text-orange-500 ml-2" />
                      <span>{event.time}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-600 text-xs">
                      <FaTag className="text-orange-500" />
                      <span>📍 {event.venue}</span>
                    </div>
                    <p className="text-gray-500 text-xs mt-2">{event.description}</p>
                    <button className="mt-2 bg-gradient-to-r from-orange-500 to-pink-500 text-white px-4 py-1.5 rounded-lg text-xs font-semibold hover:shadow-md transition-all w-full">
                      Register Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Announcements Tab */}
          {activeTab === 'announcements' && (
            <div className={`bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-500 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}>
              <div className="bg-gradient-to-r from-yellow-500 via-orange-500 to-pink-500 p-3">
                <h3 className="text-white font-bold text-center text-lg">Latest Announcements</h3>
              </div>
              <div className="divide-y divide-gray-100">
                {announcements.map((announcement, idx) => (
                  <div key={announcement.id} className="p-4 hover:bg-gradient-to-r hover:from-yellow-50 hover:to-pink-50 transition-all flex items-center justify-between">
                    <div className="flex items-center gap-3 flex-1">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-r from-yellow-100 to-orange-100 flex items-center justify-center text-orange-500">
                        {announcement.icon}
                      </div>
                      <div>
                        <p className="text-gray-800 font-medium text-sm">{announcement.title}</p>
                        <div className="flex items-center gap-2 mt-1">
                          <FaCalendarAlt className="text-gray-400 text-xs" />
                          <span className="text-gray-400 text-xs">{announcement.date}</span>
                          <span className={`text-xs px-2 py-0.5 rounded-full ${
                            announcement.type === 'Achievement' ? 'bg-yellow-100 text-yellow-600' :
                            announcement.type === 'Scholarship' ? 'bg-green-100 text-green-600' :
                            announcement.type === 'Exam' ? 'bg-red-100 text-red-600' :
                            announcement.type === 'Event' ? 'bg-purple-100 text-purple-600' :
                            announcement.type === 'Vacation' ? 'bg-blue-100 text-blue-600' :
                            'bg-gray-100 text-gray-600'
                          }`}>
                            {announcement.type}
                          </span>
                        </div>
                      </div>
                    </div>
                    <button className="text-orange-500 text-xs font-semibold hover:underline">Details →</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* View All Button */}
          <div className={`text-center mt-10 transition-all duration-500 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}>
            <button className="bg-gradient-to-r from-yellow-500 via-orange-500 to-pink-500 text-white px-6 py-2.5 rounded-xl font-semibold text-sm hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center gap-2 mx-auto">
              View All News & Events
              <FaArrowRight className="text-sm" />
            </button>
          </div>

          {/* Bottom Decorative */}
          <div className="mt-10 flex justify-center gap-2">
            <div className="w-2 h-2 bg-yellow-400 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-2 h-2 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        .animate-bounce {
          animation: bounce 1s ease-in-out infinite;
        }
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </section>
  );
};

export default NewsSection;